/**
 * Klab MMP People API
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { EmployeeConfigurationCreateRequest } from '../model/employeeConfigurationCreateRequest';
// @ts-ignore
import { EmployeeConfigurationExportRequest } from '../model/employeeConfigurationExportRequest';
// @ts-ignore
import { EmployeeConfigurationUpdateRequest } from '../model/employeeConfigurationUpdateRequest';
// @ts-ignore
import { EmployeeConfigurationByIdResponse } from '../model/employeeConfigurationByIdResponse';
// @ts-ignore
import { PagedEmployeeConfigurationResponse } from '../model/pagedEmployeeConfigurationResponse';
// @ts-ignore
import { EmployeeConfigurationInternalResponse } from '../model/employeeConfigurationInternalResponse';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';


@Injectable({
  providedIn: 'root'
})
export class EmployeeConfigurationsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get all employee configurations with pagination and filtering
     * @endpoint get /api/v1/employee-configurations
     * @param page Page number (0-indexed)
     * @param size Number of items per page
     * @param locationId Filter by location ID
     * @param workModality Filter by work modality
     * @param roleId Filter by role ID
     */
    public getAllEmployeeConfigurations(page?: number, size?: number, locationId?: number, workModality?: 'HYBRID' | 'OFFICE' | 'REMOTE', roleId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedEmployeeConfigurationResponse>;
    public getAllEmployeeConfigurations(page?: number, size?: number, locationId?: number, workModality?: 'HYBRID' | 'OFFICE' | 'REMOTE', roleId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedEmployeeConfigurationResponse>>;
    public getAllEmployeeConfigurations(page?: number, size?: number, locationId?: number, workModality?: 'HYBRID' | 'OFFICE' | 'REMOTE', roleId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedEmployeeConfigurationResponse>>;
    public getAllEmployeeConfigurations(page?: number, size?: number, locationId?: number, workModality?: 'HYBRID' | 'OFFICE' | 'REMOTE', roleId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        let localVarQueryParameters = new OpenApiHttpParams();
        if (page !== undefined && page !== null) {
            localVarQueryParameters = localVarQueryParameters.append('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            localVarQueryParameters = localVarQueryParameters.append('size', <any>size);
        }
        if (locationId !== undefined && locationId !== null) {
            localVarQueryParameters = localVarQueryParameters.append('locationId', <any>locationId);
        }
        if (workModality !== undefined && workModality !== null) {
            localVarQueryParameters = localVarQueryParameters.append('workModality', <any>workModality);
        }
        if (roleId !== undefined && roleId !== null) {
            localVarQueryParameters = localVarQueryParameters.append('roleId', <any>roleId);
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/api/v1/employee-configurations`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedEmployeeConfigurationResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get employee configuration by ID
     * @endpoint get /api/v1/employee-configurations/{employeeConfigurationId}
     * @param employeeConfigurationId Employee configuration ID
     */
    public getEmployeeConfigurationById(employeeConfigurationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EmployeeConfigurationByIdResponse>;
    public getEmployeeConfigurationById(employeeConfigurationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EmployeeConfigurationByIdResponse>>;
    public getEmployeeConfigurationById(employeeConfigurationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EmployeeConfigurationByIdResponse>>;
    public getEmployeeConfigurationById(employeeConfigurationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (employeeConfigurationId === null || employeeConfigurationId === undefined) {
            throw new Error('Required parameter employeeConfigurationId was null or undefined when calling getEmployeeConfigurationById.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/api/v1/employee-configurations/${this.configuration.encodeParam({name: "employeeConfigurationId", value: employeeConfigurationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<EmployeeConfigurationByIdResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update employee configuration
     * @endpoint put /api/v1/employee-configurations/{employeeConfigurationId}
     * @param employeeConfigurationId Employee configuration ID
     * @param employeeConfigurationUpdateRequest
     */
    public updateEmployeeConfiguration(employeeConfigurationId: number, employeeConfigurationUpdateRequest: EmployeeConfigurationUpdateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public updateEmployeeConfiguration(employeeConfigurationId: number, employeeConfigurationUpdateRequest: EmployeeConfigurationUpdateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public updateEmployeeConfiguration(employeeConfigurationId: number, employeeConfigurationUpdateRequest: EmployeeConfigurationUpdateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public updateEmployeeConfiguration(employeeConfigurationId: number, employeeConfigurationUpdateRequest: EmployeeConfigurationUpdateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (employeeConfigurationId === null || employeeConfigurationId === undefined) {
            throw new Error('Required parameter employeeConfigurationId was null or undefined when calling updateEmployeeConfiguration.');
        }
        if (employeeConfigurationUpdateRequest === null || employeeConfigurationUpdateRequest === undefined) {
            throw new Error('Required parameter employeeConfigurationUpdateRequest was null or undefined when calling updateEmployeeConfiguration.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/api/v1/employee-configurations/${this.configuration.encodeParam({name: "employeeConfigurationId", value: employeeConfigurationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: employeeConfigurationUpdateRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get employee configuration (internal)
     * Internal API — requires API key.
     * @endpoint get /api/v1/internal/employee-configurations
     * @param employeeId Employee ID
     * @param employeeEmail Employee Email
     */
    public getEmployeeConfiguration(employeeId?: number, employeeEmail?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EmployeeConfigurationInternalResponse>;
    public getEmployeeConfiguration(employeeId?: number, employeeEmail?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EmployeeConfigurationInternalResponse>>;
    public getEmployeeConfiguration(employeeId?: number, employeeEmail?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EmployeeConfigurationInternalResponse>>;
    public getEmployeeConfiguration(employeeId?: number, employeeEmail?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        let localVarQueryParameters = new OpenApiHttpParams();
        if (employeeId !== undefined && employeeId !== null) {
            localVarQueryParameters = localVarQueryParameters.append('employeeId', <any>employeeId);
        }
        if (employeeEmail !== undefined && employeeEmail !== null) {
            localVarQueryParameters = localVarQueryParameters.append('employeeEmail', <any>employeeEmail);
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (apiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKeyAuth', 'x-api-key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/api/v1/internal/employee-configurations`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<EmployeeConfigurationInternalResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export employee configurations list (CSV/Excel). Streams the file as a Blob.
     * Manually added to expose POST /api/v1/employee-configurations/export.
     */
    public exportEmployeeConfigurations(employeeConfigurationExportRequest: EmployeeConfigurationExportRequest, context?: HttpContext): Observable<Blob> {
        if (employeeConfigurationExportRequest === null || employeeConfigurationExportRequest === undefined) {
            throw new Error('Required parameter employeeConfigurationExportRequest was null or undefined when calling exportEmployeeConfigurations.');
        }

        let localVarHeaders = this.defaultHeaders;
        localVarHeaders = localVarHeaders.set('Content-Type', 'application/json');

        const localVarPath = `/api/v1/employee-configurations/export`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('post', `${basePath}${localVarPath}`,
            {
                context: context,
                body: employeeConfigurationExportRequest,
                responseType: 'blob',
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: 'body',
                reportProgress: false
            }
        );
    }

    /**
     * Export a single employee configuration detail (CSV/Excel). Streams the file as a Blob.
     * Manually added to expose POST /api/v1/employee-configurations/{employeeConfigurationId}/export.
     */
    public exportEmployeeConfigurationDetail(employeeConfigurationId: number, body: { format: string }, context?: HttpContext): Observable<Blob> {
        if (employeeConfigurationId === null || employeeConfigurationId === undefined) {
            throw new Error('Required parameter employeeConfigurationId was null or undefined when calling exportEmployeeConfigurationDetail.');
        }

        let localVarHeaders = this.defaultHeaders;
        localVarHeaders = localVarHeaders.set('Content-Type', 'application/json');

        const localVarPath = `/api/v1/employee-configurations/${encodeURIComponent(String(employeeConfigurationId))}/export`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('post', `${basePath}${localVarPath}`,
            {
                context: context,
                body: body,
                responseType: 'blob',
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: 'body',
                reportProgress: false
            }
        );
    }
}
